/** VUEX module for contract management */
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    // initial state
    modeReadFrom: 'local disk',

    isCreating: false,
  },
  getters: {
    // getters
    modeReadFrom: state => state.modeReadFrom,
  },
  mutations: {
    // mutations
    MODE_READ_FROM: (state, mode) => {
      state.modeReadFrom = mode;
    },
    FETCH_CREATE_START: state => {
      state.isCreating = true;
    },
  },
  actions: {
    // actions
    FETCH_MODE: ({ commit }) => {
      return new Promise((resolve, reject) => {
        this.$httpMain
          .get('read-from')
          .then(res => {
            resolve(res);
            if (res.data === 0) commit('MODE_READ_FROM', 'local disk');
            if (res.data === 1) commit('MODE_READ_FROM', 'external disk');
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    FETCH_UPDATE_MODE: ({ commit }, mode) => {
      return new Promise((resolve, reject) => {
        this.$httpMain
          .post('read-from', {
            mode: mode,
          })
          .then(res => {
            resolve(res);
            if (mode === 0) commit('MODE_READ_FROM', 'local disk');
            if (mode === 1) commit('MODE_READ_FROM', 'external disk');
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    FETCH_CREATE: ({ commit }, payload) => {
      commit('FETCH_CREATE_START');
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$httpActivity({ url: 'serve-lesson', data: payload.data, method: 'POST' })
          .then(response => {
            resolve(response);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
  },
};
